/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Reports/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Reports({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Reports",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2
  
}) {
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
let fill2OrdtColorsBlack = fill2 ?? dtColorsBlack
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Reports.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-13mzue': alignSelf,'--mt-2-13mzue': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-13mzue': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-13mzue': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-13mzue': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-13mzue': opacity,'--w-10-13mzue': typeof width === 'number' ? `${width}px` : width,'--h-11-13mzue': typeof height === 'number' ? `${height}px` : height,'--f-12-13mzue': fill,'--a-7-13mzue': isAnimated ? animation : "none",'--sd-8-13mzue': isAnimated ? strokeDashoffset : 0,'--sd-9-13mzue': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Reports.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M4.323 3.25a1.071 1.071 0 00-2.143 0v2.024a1.071 1.071 0 002.143 0V3.25zm0 5.158a1.071 1.071 0 00-2.143 0v2.023a1.071 1.071 0 002.143 0V8.408zM3.25 12.495c.592 0 1.072.48 1.072 1.071v2.024a1.072 1.072 0 01-2.143 0v-2.024c0-.591.48-1.071 1.071-1.071zm1.072 6.23a1.071 1.071 0 10-2.143 0v2.024c0 .592.48 1.071 1.071 1.071h2.024a1.071 1.071 0 000-2.143h-.952v-.952zM21.82 20.75c0 .592-.48 1.072-1.072 1.072h-2.023a1.071 1.071 0 010-2.143h2.023c.592 0 1.072.48 1.072 1.071zm-6.229 1.07a1.071 1.071 0 100-2.143h-2.024a1.071 1.071 0 000 2.143h2.024zm-4.086-1.071c0 .591-.48 1.071-1.072 1.071H8.41a1.071 1.071 0 110-2.143h2.023c.592 0 1.072.48 1.072 1.072zm5.443-12.473a2.578 2.578 0 112.148.028 8.975 8.975 0 01-8.269 8.236 2.578 2.578 0 11-.025-2.149 6.833 6.833 0 006.146-6.115z"
 style={{'--f-12-13mzue': fill2OrdtColorsBlack}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}